import { computed } from "vue";
import { route } from "@/router";

export function useRouteParams() {
    const locationId = computed<string>(() => String(route.value.params.locationId ?? ''))

    return {
        locationId
    }
}
